import { render, staticRenderFns } from "./IconChevronsRight.vue?vue&type=template&id=45f25612&scoped=true&"
import script from "./IconChevronsRight.vue?vue&type=script&lang=ts&"
export * from "./IconChevronsRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f25612",
  null
  
)

export default component.exports